import { render, staticRenderFns } from "./ViewPublic.vue?vue&type=template&id=5addd78c"
import script from "./ViewPublic.vue?vue&type=script&lang=js"
export * from "./ViewPublic.vue?vue&type=script&lang=js"
import style0 from "./ViewPublic.vue?vue&type=style&index=0&id=5addd78c&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports